import * as React from "react";
const SvgDropdownIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "49.84 75.56 2.94 29.93 96.75 29.93 49.84 75.56" }));
export default SvgDropdownIcon;
